<template>
  <div class="page-section">
    <h1 class="info-title">
      Free up <b>extra money</b>
    </h1>
    <p class="section-subtitle">
      If you implement these tips, you could potentially save extra <b>£{{ numberToHumanReadable(totalSavings) }}
        per month.</b>
    </p>
    <div
      v-if="isDataMissing"
      class="connect-another-subtitle"
    >
      We don't have enough data to display your Saving tips.
      <b @click="handleConnectAccountsClick">connect an active account</b>
      to get the full picture.
    </div>
    <div class="scroll-container">
      <horizontal-scroll>
        <div v-for="(tip, index) in displayTips" :key="index" class="card" :class="{ 'disabled': isDataMissing }">
          <div class="tip-number">
            {{ index + 1 }}
          </div>
          <div class="tip-text">
            {{ tip.text }}
          </div>
        </div>
      </horizontal-scroll>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { numberToHumanReadable } from '../../../../utils/miscUtils';
import HorizontalScroll from '../../../Common/HorizontalScroll.vue';

const props = defineProps({
  tips: {
    type: Array,
    required: true,
  },
  totalSavings: {
    type: Number,
    required: true,
  },
  isDataMissing: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['connectAccountsClick']);

const displayTips = computed(() => {
  if (props.isDataMissing) {
    return [
      { text: 'Connect another account to get these saving tips' },
      { text: 'Connect another account to get these saving tips' },
    ];
  }

  return props.tips;
});

const handleConnectAccountsClick = () => {
  emit('connectAccountsClick');
};
</script>

<style lang="scss" scoped>
@import '../../../../scss/riseup-vars';

.page-section {
  background-color: #FCF7ED;
  color: #202125;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 81px;
}

.info-title {
  font-size: 36px;
  padding-top: 40px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.info-title b {
  font-weight: 700;
}

.section-subtitle {
  font-size: 17px;
  margin-top: 25px;
  margin-bottom: 40px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.connect-another-subtitle {
  font-size: 14px;
  margin-bottom: 10px;
  margin-top: 10px;
  background-color: #FFDC73;
  color: #202125;
  text-align: center;
  padding: 20px;
  border-radius: 16px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
}

.connect-another-subtitle b {
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.scroll-container {
  position: relative;
  z-index: 2;
  margin-bottom: -50px;
}

.card {
  z-index: 1;
  flex: 0 0 300px;
  background-color: white;
  border-radius: 25px;
  padding: 28px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-height: 330px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.card.disabled {
  background-color: #F1F5FA !important;
  box-shadow: 0px 16px 46.4px 0px #00000010 !important;
  border-radius: 25px;
  pointer-events: none;

  .tip-number {
    background-color: #E0E4EA !important;
  }
}

.tip-number {
  width: 36px;
  height: 36px;
  background-color: #E7510F;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  font-weight: bold;
  color: #FFFFFF;
  margin-bottom: 20px;
}

.tip-text {
  font-size: 17px;
  color: #205441;
  line-height: 1.5;
  flex: 1;
  width: 100%;
  white-space: normal;
  margin-bottom: 30px;
}
</style>
